<template>
  <div class="page-busi-opportunity">
    <crm-panel :title="'商机列表'">
      <div class="page-buttons">
        <crm-button
          v-if="businessAuth.bizAdd && businessAuth.bizAdd.toggleStatus"
          :buttonType="'secondary'"
          :text="'新增'"
          @click="handleAddBusi()"
        >
        </crm-button>
        <crm-button
          v-if="businessAuth.bizDownload && businessAuth.bizDownload.toggleStatus"
          :buttonType="'plain'"
          :text="'导出'"
          :disabled="isDownload"
          @click="handleExport()"
        >
        </crm-button>
      </div>
      <!-- 搜索条 -->
      <div class="mt20">
        <el-form ref="form" :inline="true" :model="searchForm">
          <el-form-item label="">
            <el-select clearable v-model="searchForm.businessType" placeholder="商机阶段">
              <el-option
                :key="item.uid"
                v-for="item in busiStageList"
                :label="item.name"
                :value="item.uid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-cascader
              ref="cascader"
              :options="allProductLine"
              :props="{
                value: 'id',
                label: 'name',
                children: 'productLineList',
              }"
              clearable
              placeholder="请选择产品线"
              v-model="searchForm.businessLineArr"
            >
            </el-cascader>
            <!-- <el-select
              clearable
              v-model="searchForm.businessLine"
              placeholder="产品线"
            >
              <el-option
                :key="item.uid"
                v-for="item in busiLineList"
                :label="item.name"
                :value="item.uid"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="searchForm.protecPeriodStr"
              clearable
              placeholder="保护期倒计时"
            >
              <we-protect-period-options v-once />
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <crm-cascader
              :value="searchForm.teamIds"
              :options="teamList"
              placeholder="团队"
              clearable
              :props="{ multiple: true, checkStrictly: true }"
              :show-all-levels="false"
              @change="handleParentTeam"
            >
            </crm-cascader>
          </el-form-item>
          <el-form-item label="">
            <div class="select-data-picker">
              <el-select v-model="searchDateType" style="width: 145px">
                <el-option label="创建时间" :value="1"></el-option>
                <el-option label="最新阶段变更时间" :value="2"></el-option>
              </el-select>
              <el-date-picker
                value-format="yyyy-MM-dd"
                :editable="false"
                v-model="datePicker"
                type="daterange"
                range-separator="至"
                start-placeholder="创建日期始"
                end-placeholder="创建日期止"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="">
            <el-input
              placeholder="根据名称查询"
              v-model="searchName"
              class="input-with-select"
            >
              <el-select v-model="searchNameType" slot="prepend">
                <we-search-input-type-options v-once />
              </el-select>
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 商机列表 -->
      <el-table
        :data="busiOpportunityList.results"
        v-loading="tableLoading"
        height="100%"
        border
        style="width: 100%"
      >
        <el-table-column
          show-overflow-tooltip
          fixed="left"
          prop="name"
          label="商机名称"
          align="center"
        >
          <template slot-scope="scope">
            <span
              v-if="businessAuth.bizDetailTab && businessAuth.bizDetailTab.toggleStatus"
              class="link busi-name"
              @click.stop="handleBusiDetailShow(scope)"
            >
              {{ scope.row.name || "暂无数据" }}
            </span>
            <span v-else>
              {{ scope.row.name || "暂无数据" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          fixed="left"
          prop="customerName"
          label="客户名称"
          align="center"
        >
          <template slot-scope="scope">
            <span
              v-if="
                customAuth.customerDetailTab && customAuth.customerDetailTab.toggleStatus
              "
              class="link"
              @click="handleCustomClick(scope)"
            >
              {{ scope.row.customerName || "暂无数据" }}
            </span>
            <span v-else>
              {{ scope.row.customerName || "暂无数据" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="businessLineName"
          label="产品线"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.businessLineName || "暂无数据" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="businessTypeName" label="商机阶段" width="70" align="center">
        </el-table-column>
        <el-table-column prop="userName" label="业务员" width="70" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.userName || "暂无数据" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="intention"
          width="160"
          label="客户意向"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="stageChangeDate"
          label="最新阶段变更时间"
          width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="gmtCreatedStr" label="创建时间" width="100" align="center">
        </el-table-column>
        <el-table-column fixed="right" width="120" label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="visitAuth.visitAdd && visitAuth.visitAdd.toggleStatus"
              @click="toVisit(scope.row)"
              type="text"
              size="small"
            >
              拜访
            </el-button>
            <el-button
              v-if="businessAuth.bizUpdate && businessAuth.bizUpdate.toggleStatus"
              @click="handleUpdate(scope)"
              type="text"
              size="small"
            >
              编辑
            </el-button>
            <el-button
              v-if="businessAuth.bizDelete && businessAuth.bizDelete.toggleStatus"
              @click="handleDelete(scope)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 商机列表分页 -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchForm.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="searchForm.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="busiOpportunityList.totalCount"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <!-- 商机详情面板 -->
    <busi-detail
      :nextButtonState="nextButtonState"
      v-show="busiDetailVisible"
      :detailId="detailId"
      :isShangJi="true"
      @handleCloseBusiDetail="handleCloseBusiDetail"
    >
    </busi-detail>

    <!-- 客户详情面板 -->
    <we-custom-details
      v-show="customDetailShow"
      v-bind="viewPanel"
      :sourcePart="'customer'"
      @closeCustomDetail="closeCustomDetail"
      @saveEditCustom="handleSearch"
    >
    </we-custom-details>

    <add-busi
      v-if="isAddBusiVisible"
      :moduleName="'opportunity'"
      :visible="isAddBusiVisible"
      @close="isAddBusiVisible = false"
      @success="handleSearch"
    >
    </add-busi>
    <edit-busi
      v-if="isEditBusiVisible"
      :visible="isEditBusiVisible"
      :detail="detail"
      :moduleName="'opportunity'"
      @close="isEditBusiVisible = false"
      @success="saveAddUpdate"
    >
    </edit-busi>
    <!-- 新增 -->
    <add-visit
      v-if="isAddVisitVisible"
      :visible="isAddVisitVisible"
      :detail="visitDetail"
      @close="isAddVisitVisible = false"
    >
    </add-visit>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import { formatTimeShow, newDownloadByUrl } from "@/scripts/utils";
import config from "~config";
import BusiDetail from "~component/business/busiopportunity/busiDetail";
import WeSearchInputTypeOptions from "~component/business/busiopportunity/search-input-type-options";
import WeProtectPeriodOptions from "~component/business/busiopportunity/protect-period-options";
import WeCustomDetails from "~component/business/custom/customDetails";
import CrmPanel from "@/components/base/crmPanel";
import CrmButton from "@/components/base/crmButton";
import AddBusi from "~component/business/busiopportunity/addBusi";
import EditBusi from "~component/business/busiopportunity/editBusi.vue";
import CrmCascader from "@/components/base/crmCascader";
import AddVisit from "@/components/business/visit/addVisit";
import service from "@/services/api/common";
export default {
  components: {
    BusiDetail,
    WeSearchInputTypeOptions,
    WeProtectPeriodOptions,
    WeCustomDetails,
    CrmPanel,
    CrmButton,
    AddBusi,
    EditBusi,
    CrmCascader,
    AddVisit,
  },
  filters: {
    formatTimeShow,
  },
  data() {
    return {
      isDownload: false,
      searchDateType: 1,
      searchNameType: "name",
      searchName: "",
      datePicker: [],
      tableLoading: false,
      searchForm: {
        businessType: "",
        changeTime: [],
        time: [],
        teamIds: "",
        businessLineArr: [],
        businessLine: "",
        protecPeriodStr: "",
        pageSize: 10,
        pageNumber: 1,
      },
      isAddBusiVisible: false,
      isEditBusiVisible: false,
      // 编辑详情
      detail: {},
      isAdd: false,
      // 商机详情
      busiDetailVisible: false,
      detailId: "",
      nextButtonState: false,
      // 查看客户详情
      customDetailShow: false,
      // 客户详情
      customRow: {},
      viewPanel: {
        uid: "",
        type: 1,
        teamId: 1,
        authEdit: true,
        authDelete: true,
      },
      isAddVisitVisible: false,
      clueDetail: {},
      // 新版产品线
      allProductLine: [],
    };
  },
  computed: {
    ...mapGetters({
      businessAuth: "authority/businessAuth",
      visitAuth: "authority/visitAuth",
      customAuth: "authority/customAuth",
      userInfo: "authority/userInfo",
      busiStageList: "business/busiStageList",
      busiLineList: "business/busiLineList",
      busiOpportunityList: "business/busiOpportunityList",
      busiOpportunityDetail: "business/busiOpportunityDetail",
      detailContacts: "business/detailContacts",
      customDetail: "customer/customDetail",
      teamList: "business/teamList",
    }),
  },
  watch: {
    "searchForm.businessType": {
      handler: "handleSearch",
    },
    datePicker: {
      handler: "handleSearch",
    },
    "searchForm.businessLineArr": {
      handler: "handleSearch",
    },
    "searchForm.protecPeriodStr": {
      handler: "handleSearch",
    },
    "searchForm.teamIds": {
      handler: "handleSearch",
    },
    searchDateType: {
      handler: "handleSearch",
    },
  },
  created() {
    if (JSON.stringify(this.$route.params) !== "{}") {
      this.searchDateType = this.$route.params.searchDateType
        ? this.$route.params.searchDateType
        : 1;
      this.datePicker = this.$route.params.datePicker
        ? this.$route.params.datePicker
        : [];
    }
    this.searchForm.teamIds = [this.userInfo.teamId];
    this.getQueryTeam();
    this.getBusiStageList({
      pageNumber: this.searchForm.pageNumber,
      pageSize: this.searchForm.pageSize,
      code: "category_business_type",
    });
    // 更新新版产品线下拉
    this.getAllProductLine();
    // this.getBusiLineList({
    //   pageNumber: this.searchForm.pageNumber,
    //   pageSize: this.searchForm.pageSize,
    //   code: 'category_business_line',
    // });
    this.handleSearch();
    if (Object.keys(this.customAuth).length === 0)
      this.getAuthority({ menuUrl: "/customer/valid" });
    this.getAuthority({ menuUrl: "/visit" });
    this.getAuthority({ menuUrl: "/business/opportunity" });
  },
  methods: {
    ...mapActions({
      getAuthority: "authority/getAuthority",
      getBusiStageList: "business/getBusiStageList",
      getBusiLineList: "business/getBusiLineList",
      getBusiOpportunityList: "business/getBusiOpportunityList",
      saveAddBusiOpprtunity: "business/saveAddBusiOpprtunity",
      deleteBusiOpportunity: "business/deleteBusiOpportunity",
      getBusiOpprtunityDetail: "business/getBusiOpprtunityDetail",
      saveBusiAbolish: "business/saveBusiAbolish",
      saveBusiRecover: "business/saveBusiRecover",
      getCustomDetail: "customer/getCustomDetail",
      getDetailContactsList: "business/getDetailContactsList",
      exportBusiOpportunity: "business/exportBusiOpportunity",
      getQueryTeam: "business/getQueryTeam",
    }),
    getAllProductLine() {
      service.queryProductLineListForSearch().then((res) => {
        res.data.data.forEach((item) => {
          this.allProductLine.push({
            ...item,
            id: item.typeCode,
            name: item.typeName,
          });
        });
      });
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      if (this.searchDateType === 1) {
        this.searchForm.time = this.datePicker;
      } else {
        this.searchForm.changeTime = this.datePicker;
      }
      this.getBusiOpportunityData();
    },
    getBusiOpportunityData() {
      this.tableLoading = true;
      const params = this.handleSearchData();
      this.getBusiOpportunityList(params).finally(() => {
        this.tableLoading = false;
      });
    },
    handleSearchData() {
      const nameList = ["name", "customerName", "customerNo", "userName"];
      nameList.forEach((i) => {
        this.searchForm[i] = null;
      });
      if (this.searchName) this.searchForm[this.searchNameType] = this.searchName;

      const dateList = [
        "startDateStr",
        "endDateStr",
        "stageChangeStartDate",
        "stageChangeEndDate",
      ];
      dateList.forEach((i) => {
        this.searchForm[i] = null;
      });
      if (this.searchDateType === 1) {
        this.searchForm.startDateStr = this.searchForm.time
          ? this.searchForm.time[0]
          : "";
        this.searchForm.endDateStr = this.searchForm.time ? this.searchForm.time[1] : "";
      } else {
        this.searchForm.stageChangeStartDate = this.searchForm.changeTime
          ? this.searchForm.changeTime[0]
          : "";
        this.searchForm.stageChangeEndDate = this.searchForm.changeTime
          ? this.searchForm.changeTime[1]
          : "";
      }
      const {
        time,
        changeTime,
        businessLine,
        businessLineArr,
        ...otherParams
      } = this.searchForm;
      return {
        businessLine: businessLineArr.length >= 2 ? businessLineArr[1] : "",
        ...otherParams,
      };
    },
    handleParentTeam(teamInfo) {
      console.log(teamInfo);
      if (teamInfo.type && teamInfo.type === "multiple") {
        this.searchForm.teamIds = teamInfo.value;
      } else {
        this.searchForm.teamIds = teamInfo[teamInfo.length - 1];
      }
    },
    handleExport() {
      this.notify = this.$notify({
        iconClass: "el-icon-loading",
        title: "",
        message: "正在导出中，请稍后...",
        duration: 0,
        showClose: false,
      });
      const params = this.handleSearchData();
      this.isDownload = true;
      const url = `${config.api || ""}/api/crmbusiness/download`;
      newDownloadByUrl(url, "post", params).finally(() => {
        this.notify.close();
        this.isDownload = false;
      });
    },
    // 添加编辑
    handleAddBusi() {
      this.isAddBusiVisible = true;
    },
    handleUpdate(scope) {
      this.isAdd = false;
      this.tableLoading = true;
      // this.getBusiOpprtunityDetail({ id: scope.row.id }).then((res) => {
      //   console.log(res)
      // }).catch((error) => {
      //   console.log(error)
      // })
      Promise.all([
        this.getBusiOpprtunityDetail({ id: scope.row.id }),
        this.getDetailContactsList({
          businessId: scope.row.id,
          pageSize: 20,
          pageNumber: 1,
        }),
      ])
        .then(() => {
          const nextForm = this.$_.pick(this.busiOpportunityDetail, [
            "id",
            "customerName",
            "customerId",
            "businessLine",
            "name",
            "intention",
            "dealAmountStr",
            "dealDateStr",
            "remarks",
            "userId",
            "productLineList",
            "businessNo",
          ]);
          nextForm.converts = [];
          this.detailContacts.results.forEach((item) => {
            nextForm.converts.push(item.uid);
          });
          this.detail = nextForm;
          this.isEditBusiVisible = true;
          this.tableLoading = false;
        })
        .catch((error) => {
          this.isEditBusiVisible = false;
          this.tableLoading = false;
        });
    },
    saveAddUpdate() {
      this.isAdd = false;
      this.handleSearch();
    },
    // 商机详情
    async handleBusiDetailShow(scope) {
      if (this.businessAuth?.bizDetailTab?.toggleStatus) {
        await this.getBusiOpprtunityDetail({ id: scope.row.id })
          .then((res) => {
            this.nextButtonState = true;
            this.detailId = scope.row.id;
            this.busiDetailVisible = true;
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$message.error("无操作权限!");
      }
    },
    handleCloseBusiDetail(isRefresh) {
      this.busiDetailVisible = false;
      this.nextButtonState = false;
      if (isRefresh) {
        this.getBusiOpportunityData();
      }
    },
    // 客户详情跳转
    goCostumDetail(scope) {
      this.$router.push({
        name: "customer",
        query: {
          uid: scope.row.uid,
          type: scope.row.type,
        },
      });
    },
    handleDelete(scope) {
      this.$confirm("是否确定删除商机？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteBusiOpportunity({
            id: scope.row.id,
          }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.handleSearch();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleCurrentChange(val) {
      this.searchForm.pageNumber = val;
      this.getBusiOpportunityData();
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.searchForm.pageNumber = 1;
      this.getBusiOpportunityData();
    },
    // 客户详情
    async handleCustomClick(scope) {
      if (scope.row.customerIsDeleted === 1) {
        this.$message({
          type: "error",
          message: "该客户不存在或已删除",
        });
      } else {
        this.customRow = scope.row;
        this.customDetailShow = true;
        this.viewPanel = Object.assign(this.viewPanel, {
          uid: scope.row.customerId,
          type: scope.row.customerType,
          teamId: scope.row.teamId,
          authEdit: !scope.row.searchUid && this.customAuth.customerUpdate.toggleStatus,
          authDelete: this.customAuth.customerDelete.toggleStatus,
        });
        await this.getBusiOpprtunityDetail({ id: scope.row.id })
      }
    },
    closeCustomDetail() {
      this.customDetailShow = false;
      this.handleSearch();
    },
    // 拜访
    toVisit(row) {
      this.visitDetail = {
        visitObject: 2,
        visitObjectId: row.id,
        businessName: row.name,
        businessId: row.id,
        salesmanCode: this.userInfo.userUid,
        cluesVisible: false,
        customVisible: false,
        contactVisible: true,
        buisVisible: false,
        canEdit: false,
      };
      this.isAddVisitVisible = true;
      console.log(this.visitDetail, "this.visitDetail");
    },
  },
};
</script>

<style lang="less">
@import "~@/styles/var.less";

.page-busi-opportunity {
  display: flex;
  flex: 1;
  width: 100%;
  overflow: hidden;
  .search-item-name {
    .el-form-item__content {
      display: inline-block;
    }
  }
  .dialog-busi-detail {
    z-index: 9;
    position: fixed;
    top: 0;
    right: 0;
    width: 80%;
    height: 100%;
    background-color: #ffffff;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.3);
  }
  .slide-fade-enter-active {
    transition: all 0.5s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.5s ease;
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }
  .busi-dialog {
    padding: 0 30px;
    .el-form-item__label {
      float: none;
    }
  }
  .dialog-title {
    text-align: center;
    margin-bottom: 20px;
    font-size: 18px;
  }
  .content {
    padding: 0 40px;
    .pageination {
      padding: 30px 0;
      text-align: center;
    }
  }
}
</style>
